// extracted by mini-css-extract-plugin
export default {"view-credits-history-box":"view-credits-history-box_zcBOV","view-credits-history":"view-credits-history_SMLaM"};